var _defs, _path, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmoEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fefefc;\n      }\n\n      .st1 {\n        fill: #fec007;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.1,0l15.6,2.8c33.3,8.6,59.3,36.4,65.7,70.3s.8,6.6,1.6,9.9v14.1l-2.6,14.8c-8,31.9-33.6,57.7-65.5,65.6l-15.1,2.6h-13.7c-3.1-.7-6.4-.9-9.6-1.5C38,171.8,9.2,143.9,2,108.3c-.7-3.6-1-7.3-1.9-11,.3-4.8-.4-10,0-14.8C3.5,39.5,39.9,3.2,83,0h14.1ZM138.9,52.4H41.2l48.7,39,49-39ZM147.3,57c-1-.1-1.8.8-2.6,1.4-17.2,12.5-33.3,27.6-50.5,40.2s-4.5,2.8-8.4,0c-17.1-12.5-33.7-27.1-50.5-40.2s-1.7-1.5-2.6-1.8v67.3c0,1.7,1.9,3.7,3.7,3.7l108.1-.2c1.4-.3,2.8-2.2,2.8-3.5V57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.3,57v67c0,1.3-1.4,3.2-2.8,3.5l-108.1.2c-1.8,0-3.7-2-3.7-3.7V56.6c.9.2,1.8,1.2,2.6,1.8,16.8,13.1,33.4,27.7,50.5,40.2s4.5,2.8,8.4,0c17.2-12.6,33.3-27.7,50.5-40.2.8-.6,1.6-1.5,2.6-1.4Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "138.9 52.4 89.9 91.4 41.2 52.4 138.9 52.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmoEmailIcon);
export default __webpack_public_path__ + "static/media/OMO-Email-Icon.e0ad7f10520c7ef3f46194401c121589.svg";
export { ForwardRef as ReactComponent };